require("./header.scss")
import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { JwtHelper } from 'angular2-jwt';

import { OauthHelper } from '../../services/webservice';
import { UserProfile } from '../../models/';
import { ImpersonatorService } from '../../services';

import { Loader } from '../../ui-helper'

import { ShoppingCartHeaderOverview } from './shopping-cart-header-overview'

@Component({
	selector: 'header',
	templateUrl: "./header.html",
	styles: [require("./header.scss")]
})

export class HeaderComponent {

	public userProfile: UserProfile;
	public merchantLogoUrl: string;

	private jwtHelper: JwtHelper = new JwtHelper();

	private showHelpPopup: boolean = false;

	constructor(private oauthHelper: OauthHelper, private impersonatorService: ImpersonatorService) {
		this.createUserProfile();
	}

	ngOnInit() {
		this.userProfile.merchantId
		this.merchantLogoUrl = ZUUL_BACKEND + "/api/merchants/v1/merchantLogo/" + this.userProfile.merchantId + "/logo.img"
	}
	logout() {
			this.oauthHelper.logout();
		}

		removeImpersonation(){
			this.impersonatorService.removeImpersonate();
		}

	createUserProfile() {
		if (this.oauthHelper.getAccessToken()) {
			this.userProfile = this.jwtHelper.decodeToken(this.oauthHelper.getAccessToken())
		}
	}

	toggleHelpPopup() {
		this.showHelpPopup = !this.showHelpPopup;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/header-components/header.component.ts